export default __webpack_public_path__ + "images/6J.6fde5f4.png";